// extracted by mini-css-extract-plugin
module.exports = {"SDetailHeader":"ChartItemPremiere_SDetailHeader__FoM47"};